require('./myProfileRemoveShippingAddressView.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ actions
const myProfileShippingAddressActions = require('actions/myProfileShippingAddress');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');

// @ components
const { MyProfileEditFrame } = require('components/myProfile/myProfileEditFrame/myProfileEditFrame');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const MyProfileRemoveShippingAddressSuccess = require('components/myProfile/myProfileRemoveShippingAddress/myProfileRemoveShippingAddressSuccess/myProfileRemoveShippingAddressSuccess');
const MyProfileRemoveShippingAddressError = require('components/myProfile/myProfileRemoveShippingAddress/myProfileRemoveShippingAddressError/myProfileRemoveShippingAddressError');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const MyProfileEditShippingAddressStep1 = require('components/myProfile/myProfileEditShippingAddress/myProfileEditShippingAddressStep1/myProfileEditShippingAddressStep1');

// @utilities
const { recordProcess } = require('utilities/tagging');

// @constants
const { SHIPPING_ADDRESS_REMOVE } = require('constants/operationTypes');
const { PROC_DELETE_SHIPPING_ADDRESS } = require('utilities/tagging');

class MyProfileRemoveShippingAddressView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleRetryButton = this.handleRetryButton.bind(this);
    }

    static getDerivedStateFromProps(props) {
        const { history, immProfileShippingAddress } = props;

        if (immProfileShippingAddress.get('fetchSuccess') && !immProfileShippingAddress.get('hasShippingAddress')) {
            history.push('/myprofile/edit');
        }

        return null;
    }

    componentDidMount() {
        const {
            getShippingAddress,
            immProfileShippingAddress,
            setEditMode,
        } = this.props;

        if (!immProfileShippingAddress.get('fetchSuccess') && !immProfileShippingAddress.get('isFetching')) {
            getShippingAddress();
        }

        setEditMode();
        recordProcess(PROC_DELETE_SHIPPING_ADDRESS, 'paso_1');
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleCancel() {
        this.props.history.push('/myprofile/edit');
    }

    handleRetryButton() {
        this.props.getShippingAddress();
    }

    getOfficeModeDisclaimers() {
        const { immProfileFields } = this.props;

        let retObj = {};

        if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
            const fullName = PersonalDataHelper.getFullName(immProfileFields, false);

            retObj.ccOfficeModeDisclaimer1 = (
                <BlockInfo extraClass="show-data__block-info">
                    <p><FormattedText value="cc_profileRemoveShippingAddress-profileRemoveShippingAddress_srOrSra" /> <b>{fullName}</b></p>
                    <p><FormattedText value="cc_profileRemoveShippingAddress-profileRemoveShippingAddress_confirmationMessageOffline" /></p>
                </BlockInfo>
            );

            retObj.ccOfficeModeDisclaimer2 = (
                <BlockInfo extraClass="show-data__block-info">
                    <p><FormattedText value="cc_profileRemoveShippingAddress-profileRemoveShippingAddress_removeShippingConformity" /> <b>{fullName}</b></p>
                </BlockInfo>
            );
        }

        return retObj;
    }

    buildMainSection() {
        const { immProfileShippingAddress } = this.props;
        const officeModeDisclaimersCC = this.getOfficeModeDisclaimers();
        const addressLabel = PersonalDataHelper.getFormattedShippingAddress(immProfileShippingAddress.get('shippingAddress').toJS());
        const subtitle = formatText('profileRemoveShippingAddress-profileRemoveShippingAddress_shippingAddress');

        let confirmationMessage;

        if (__CONTACT_CENTER__) {
            if (!isPrintOfficeMode()) {
                confirmationMessage = formatText('cc_profileRemoveShippingAddress-profileRemoveShippingAddress_confirmationMessageOnline');
            }
        } else {
            confirmationMessage = formatText('profileRemoveShippingAddress-profileRemoveShippingAddress_confirmationMessage');
        }

        return (
            <React.Fragment>
                <FormattedText
                    className="profile-remove-shipping-address-view__title"
                    value="profileRemoveShippingAddress-profileRemoveShippingAddress_confirmationTitle"
                />
                <p className="profile-remove-shipping-address-view__subtitle">
                    {confirmationMessage}
                </p>
                {officeModeDisclaimersCC.ccOfficeModeDisclaimer1}
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={subtitle}
                    >
                        <span className="profile-remove-shipping-address-view__address">
                            {addressLabel}
                        </span>
                    </OKInformativeListItem>
                </OKInformativeList>
                {officeModeDisclaimersCC.ccOfficeModeDisclaimer2}
            </React.Fragment>
        );
    }

    buildBody() {
        const {
            deleteShippingAddress,
            immHireContactData,
            immProfileShippingAddress,
        } = this.props;
        const mainSection = this.buildMainSection();

        let ccPrintDocumentContent;

        if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
            ccPrintDocumentContent = (
                <div className="profile-remove-shipping-address-view__hidden">
                    <div id="printable-wizard">
                        <MyProfileEditShippingAddressStep1
                            immHireContactData={immHireContactData}
                            immProfileShippingAddress={immProfileShippingAddress}
                            isDeletePrintMode={true}
                        />
                        {mainSection}
                    </div>
                </div>
            );
        }

        return (
            <article className="profile-remove-shipping-address-view__with-frame">
                {ccPrintDocumentContent}
                {mainSection}
                <SignaturePattern
                    isInVerticalWizard={__CONTACT_CENTER__}
                    operationParams={{}}
                    operationType={SHIPPING_ADDRESS_REMOVE}
                />
                <footer className="profile-remove-shipping-address-view__footer">
                    <div className="profile-remove-shipping-address-view__first-button">
                        <OKButton
                            modifier="link-ghost"
                            onClick={this.handleCancel}
                        >
                            <FormattedText value="profileRemoveShippingAddress-profileRemoveShippingAddress_cancel" />
                        </OKButton>
                    </div>
                    <SignaturePatternButton
                        loading={immProfileShippingAddress.get('isDeleting')}
                        onClick={deleteShippingAddress}
                    >
                        <FormattedText value="profileRemoveShippingAddress-profileRemoveShippingAddress_delete" />
                    </SignaturePatternButton>
                </footer>
            </article>
        );
    }

    buildEmptyState() {
        const { immVariables } = this.props;
        const retryButton = (
            <OKButton onClick={this.handleRetryButton}>
                <FormattedText value="common-retry" />
            </OKButton>
        );
        const primaryText = formatText('profileRemoveShippingAddress-profileRemoveShippingAddress_emptyStateText', [immVariables.getIn(['telefono', 'cliente'])]);

        return (
            <div className="profile-remove-shipping-address-view__with-frame">
                <EmptyState
                    button={retryButton}
                    iconType="nointernet-banking"
                    primaryText={primaryText}
                />
            </div>
        );
    }

    render() {
        const {
            immProfileShippingAddress,
            immVariables,
        } = this.props;

        let content;
        let contentWithoutFrame;
        let contentWithFrame = (
            <OKSectionBox>
                <LoadingSection />
            </OKSectionBox>
        );

        if (immProfileShippingAddress.get('deleteSuccessful')) {
            contentWithoutFrame = (
                <div className="col-xs-offset-2 col-xs-8 profile-remove-shipping-address-view__no-frame">
                    <MyProfileRemoveShippingAddressSuccess />
                </div>
            );
        } else if (immProfileShippingAddress.get('deleteError')) {
            contentWithoutFrame = (
                <div className="col-xs-offset-2 col-xs-8 profile-remove-shipping-address-view__no-frame">
                    <MyProfileRemoveShippingAddressError
                        immVariables={immVariables}
                    />
                </div>
            );
        } else if (immProfileShippingAddress.get('fetchSuccess')) {
            contentWithFrame = this.buildBody();
        } else if (immProfileShippingAddress.get('fetchError')) {
            contentWithFrame = this.buildEmptyState();
        }

        if (!!contentWithoutFrame) {
            const titleHeader = formatText('profile-titleHeader');

            content = (
                <React.Fragment>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover
                                size="small"
                                section="pg"
                                customClass="col-xs-12"
                            >
                                <OKHeaderLanding
                                    title={titleHeader}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            {contentWithoutFrame}
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            content = (
                <MyProfileEditFrame
                    innerContent={contentWithFrame}
                    tutorialEnabled={false}
                />
            );
        }

        return content;
    }
}

MyProfileRemoveShippingAddressView.propTypes = {
    deleteShippingAddress: PropTypes.func.isRequired,
    getShippingAddress: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immProfileShippingAddress: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    setEditMode: PropTypes.func.isRequired,
};

module.exports.constructor = MyProfileRemoveShippingAddressView;
module.exports.MyProfileRemoveShippingAddressView = connect(
    state => ({
        immHireContactData: state.hireContactData,
        immProfileFields: state.profile,
        immProfileShippingAddress: state.myProfileShippingAddress,
        immVariables: state.globalVariables.getIn(['variables', 'parameters']),
    }), {
        deleteShippingAddress: myProfileShippingAddressActions.deleteShippingAddress,
        getShippingAddress: myProfileShippingAddressActions.getShippingAddress,
        reset: myProfileShippingAddressActions.reset,
        setEditMode: myProfileShippingAddressActions.setEditMode,
    })(withRouter(MyProfileRemoveShippingAddressView));
